import { Theme } from '@mui/material';

export const dtmfDialerStyles = {
  container: {
    pl: 3,
    width: 320,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },

  display: {
    minHeight: 32,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    direction: 'ltr',
    display: 'inline-block',
    textAlign: 'center`',
  },

  grid: {
    px: 3,
  },

  gridItem: {
    display: 'flex',
    justifyContent: 'center',
    py: 1,
  },
};

export const dtmfButtonStyles = {
  base: {
    width: 52,
    height: 52,
    padding: 4,
    borderRadius: '50%',
    minWidth: 52,
    transition: 'all 0.15s ease-in-out',
    '&:active': {
      transform: 'scale(0.95)',
    },
  },

  special: {
    fontWeight: 'bold',
    color: (theme: Theme) => theme.palette.secondary.main,
    backgroundColor: 'transparent',
    border: 'none',
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.secondary.states?.focus,
      borderColor: (theme: Theme) => theme.palette.secondary.main,
    },
  },

  numeric: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    border: (theme: Theme) => `1px solid ${theme.palette.secondary.main}`,
    color: (theme: Theme) => theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.secondary.states?.focus,
      borderColor: (theme: Theme) => theme.palette.secondary.main,
    },
  },

  digitTypography: {
    mb: (letters: string) => (letters ? 0 : 2.2),
  },
};
